//  export const API_URI = 'http://192.168.1.102:8087'
export const API_URI = 'https://api.configuratore-catellani.f2.net'
export const GRAPHQL_API_URI = `${API_URI}/graphql`
